import { render, staticRenderFns } from "./create-group.html?vue&type=template&id=7fb466a1&scoped=true&external"
import script from "./create-group.js?vue&type=script&lang=js&external"
export * from "./create-group.js?vue&type=script&lang=js&external"
import style0 from "./create-group.scss?vue&type=style&index=0&id=7fb466a1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb466a1",
  null
  
)

export default component.exports